import { Component, Input } from '@angular/core';
import { FileSystemFileEntry, NgxFileDropEntry } from 'ngx-file-drop';
import { BaseModalDialogDirective } from 'src/app/shared/directives/base-modal-dialog.directive';
import { Platform } from 'src/app/shared/enums/generated.enums';
import { StorageService } from 'src/app/shared/services/storage.service';
import { UploadService } from 'src/app/shared/services/upload.service';
import { ApiService } from 'src/app/shared/services/api/api.service';
import { BaseModel } from 'src/app/shared/types/generated.types';
import { TenantsService } from 'src/app/shared/services/tenants.service';
import { PlatformSpecifics } from './platform-specific.type';

@Component({
  selector: 'app-upload-files-modal',
  templateUrl: './upload-files-modal.component.html',
  styleUrls: ['./upload-files-modal.component.scss'],
  standalone: false,
})
export class UploadFilesModalComponent extends BaseModalDialogDirective {
  @Input() monitoringProcessGroupId: string;
  @Input() monitoringProcessGroupLabel: string;
  @Input() monitoringProcessesLabels: string[];

  selectedTenantId: string;
  platform: PlatformSpecifics;
  private _selectedPlatform: Platform;

  get tenants(): BaseModel[] {
    return this.tenantsService.tenants;
  }

  get selectedPlatform(): Platform {
    return this._selectedPlatform;
  }

  set selectedPlatform(selectedPlatform: Platform) {
    this._selectedPlatform = selectedPlatform;
    this.storageService.selectedPlatform = this._selectedPlatform;
    this.platform = this.getPlatformSpecifics(this._selectedPlatform);
  }

  get isTenantSelectVisible(): boolean {
    // select is visible only when more then one tenant is available
    return this.tenantsService.tenants?.length > 1 && this.tenantsService.selectedTenant == null;
  }

  constructor(private uploadService: UploadService, private storageService: StorageService, private apiService: ApiService, private tenantsService: TenantsService) {
    super();
    void this.initialize();
  }

  async initialize(): Promise<void> {
    this.selectedTenantId = this.tenantsService.selectedTenantId ?? this.tenants[0]?.id;
    await this.onTenantChanged(this.selectedTenantId);
  }

  async onTenantChanged(tenantId: string): Promise<void> {
    this.selectedTenantId = tenantId;
    const configuration = await this.apiService.tenants.getTenantConfigurationUi(tenantId);
    this.selectedPlatform = configuration?.platform ?? Platform.BluePrism;
  }

  private getPlatformSpecifics(platform: Platform): PlatformSpecifics {
    switch (platform) {
      case Platform.BluePrism:
        return new PlatformSpecifics(platform, 'Blue Prism', ['.csv']);
      case Platform.UiPath:
        return new PlatformSpecifics(platform, 'UiPath', ['.log', '.csv']);
      case Platform.AutomationAnywhere:
        return new PlatformSpecifics(platform, 'Automation Anywhere', ['.log']);
      case Platform.PowerAutomateCloud:
      case Platform.PowerAutomateDesktop:
        return new PlatformSpecifics(platform, 'Power Automate', ['.log']);
      default:
        return new PlatformSpecifics(platform, 'Other', null);
    }
  }

  onFileDrop(files: NgxFileDropEntry[]): void {
    this.close();
    files.forEach(sf => (sf.fileEntry as FileSystemFileEntry).file(f => this.uploadService.uploadProcess(f, this.selectedTenantId, this.selectedPlatform, this.monitoringProcessGroupId)));
  }
}
